module.exports = __webpack_public_path__ + "static/img/zh-Hant.d0b02ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bouns/zh-Hant.png
// module id = Hsl+
// module chunks = 1